<template>
  <div class="container unprint">
    <div class="row">
        <div class="slopePage__title"
             :class="{'details__title': isDetails}">
          <b v-text="isDetails ? 'Detailed calculation for other areas'
          :'Areas detailed calculation'"></b>
        </div>
      </div>
      <div class="row" v-if="!isDetails">
        <div class="slopePage__info">
          <img src="@/assets/img/info-result.svg" alt="info" class="slopePage__info-img">
          <div class="slopePage__info-text">
            Click on a area to view its calculation
          </div>
        </div>
      </div>
      <div class="slopePage__links">
        <router-link
            :to="`/details/${i}/`"
            class="slopePage__links-item"
            v-for="(item, i) in allSlopes"
            :key="i">
            <div class="content">
              <div class="content__img">
                <component
                  :is="allSlopes[i].slopeForm"
                  :navId="i"
                  :slopeParams="allSlopes[i].slopeParams"
                  :defaultSvgParams="defaultSvgParams"
                  :isNav="true">
                </component>
              </div>
              <div class="content__info">
                <div class="content__info-number">
                  <span v-if="(i + 1) <= 9">0</span>{{ i + 1 }}</div>
                <div class="content__info-count">x{{ allSlopes[i].slopeCount }}</div>
              </div>
            </div>
            <div class="overlay"><b>Watch calculation</b> {{ allSlopes[i].name }}</div>
          </router-link>
          <button class="slopePage__links-add" v-if="!isDetails" @click="addFromResult()">
            <svg width="24" height="24" viewBox="0 0 24 24"
                 fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="12" fill="#2ECC71"></circle>
              <path d="M12 18V6M18 12H6" stroke="#fff"
              stroke-width="2" stroke-miterlimit="22.9256" stroke-linejoin="round"></path>
            </svg>
          </button>
          <router-link to="/result/" class="slopePage__links-result" v-if="isDetails">
            <svg width="26" height="29" viewBox="0 0 26 29"
            fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M24 13.6667V3.66667C24 2.75 23.2929 2 22.4286 2H3.57143C2.70714 2 2 2.75 2
                      3.66667V13.6667M24 13.6667H2M24 13.6667L23.9999 25.3333C23.9999 26.2499
                      23.2928 26.9999 22.4285 26.9999L16.143 27M24 13.6667L16.143 13.6666M2
                      13.6667L9.07143 13.6666M2 13.6667V20.3333M9.07143 13.6666V20.3333M9.07143
                      13.6666H16.143M9.07143 20.3333H2M9.07143 20.3333V27M9.07143 20.3333H16.143M2
                      20.3333V25.3333C2 26.25 2.70714 27 3.57143 27H9.07143M9.07143 27H16.143M16.143
                      13.6666V20.3333M16.143 13.6666V27M16.143 20.3333V27" stroke="#E30713"
                      stroke-width="3" stroke-miterlimit="22.9256" stroke-linecap="round"
                      stroke-linejoin="round"></path>
            </svg>
            <span>Back to full <br>calculation</span>
          </router-link>
      </div>
  </div>
</template>

<script>
import Trapezoid from '../figures/Trapezoid.vue';
import Square from '../figures/Square.vue';
import ReverseTrapezoid from '../figures/ReverseTrapezoid.vue';
import CornerLeftTop from '../figures/CornerLeftTop.vue';
import CornerRightTop from '../figures/CornerRightTop.vue';
import CornerLeftBottom from '../figures/CornerLeftBottom.vue';
import CornerRightBottom from '../figures/CornerRightBottom.vue';
import Triangle from '../figures/Triangle.vue';
import DoubleSideTriangleHorizontal from '../figures/DoubleSideTriangleHorizontal.vue';
import DoubleSideTriangleVertical from '../figures/DoubleSideTriangleVertical.vue';
import Rhombus from '../figures/Rhombus.vue';
import RectangularTrapezoidHorizontal from '../figures/RectangularTrapezoidHorizontal.vue';
import RectangularTrapezoidVertical from '../figures/RectangularTrapezoidVertical.vue';
import DoubleSideRectangularTrapezoidVertical from
  '../figures/DoubleSideRectangularTrapezoidVertical.vue';

export default {
  props: {
    isDetails: Boolean,
  },
  data() {
    return {
    };
  },
  components: {
    Trapezoid,
    Square,
    ReverseTrapezoid,
    CornerLeftTop,
    CornerRightTop,
    CornerLeftBottom,
    CornerRightBottom,
    Triangle,
    DoubleSideTriangleHorizontal,
    DoubleSideTriangleVertical,
    Rhombus,
    RectangularTrapezoidHorizontal,
    RectangularTrapezoidVertical,
    DoubleSideRectangularTrapezoidVertical,
  },
  methods: {
    addFromResult() {
      this.$router.push(`/wizard/${parseInt(this.allSlopes.length, 10)}/`);
      this.$store.commit('addNewSlope', { id: parseInt(this.allSlopes.length, 10) + 1 });
    },
  },
  watch: {
  },
  mounted() {
  },
  computed: {
    slopeFromState() {
      return this.$store.getters.getSlope(this.slopeId);
    },
    slopeId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    allSlopes() {
      return this.$store.getters.allSlopes;
    },
    defaultSvgParams() {
      return this.$store.getters.getDafaultSvgParams;
    },
  },
};

</script>


<style lang="sass">
.slopePage
  &__title
    &.details__title
      +media((font-size: (320: rem(18), 768: rem(20), 992: rem(24))))
      +media((padding-top: (320: rem(46), 768: rem(70))))
      +media((padding-bottom: (320: rem(30), 768: rem(36))))
  &__info
    display: flex
    flex-direction: row
    align-items: center
    +media((padding-left: (320: rem(24), 992: 0)))
    +media((margin-bottom: (320: rem(28), 768: rem(37))))
    &-text
      font-style: normal
      font-weight: 500
      font-size: rem(12)
      color: $black
      padding-left: rem(21)
      text-align: left
      +media((line-height: (320: rem(20), 768: rem(24))))
      +media((padding-right: (320: rem(24), 768: 0)))
  &__links
    display: grid
    grid-column-gap: rem(1)
    grid-row-gap: rem(1)
    +media((grid-template-columns: (320: repeat(2, 1fr), 420: repeat(3, 1fr),
    576: repeat(4, 1fr), 660: repeat(5, 1fr), 768: repeat(6, 1fr))))
    +media((margin: (320: 0 rem(9), 992: 0 rem(-15))))
    &-item
      background: #fff
      text-decoration: none
      padding: rem(10)
      position: relative
      svg
        max-width: 100%
      .overlay
        padding: rem(20)
        height: 100%
        width: 100%
        position: absolute
        top: 0
        left: 0
        pointer-events: none
        background: rgba(227, 7, 19, 0.75)
        color: #fff
        transition: .5s
        display: flex
        flex-direction: column
        justify-content: center
        align-items: center
        font-style: normal
        font-weight: 500
        font-size: rem(14)
        line-height: rem(20)
        opacity: 0
        box-sizing: border-box
      &:hover
        .overlay
          opacity: 1
      .content
        &__info
          display: flex
          flex-direction: row
          align-items: center
          justify-content: space-between
          font-style: normal
          font-size: rem(14)
          line-height: 1
          color: $black
          &-number
            font-weight: bold
          &-count
            font-weight: 500
    &-add
      background: #fff
      box-shadow: none
      cursor: pointer
      border: none
      min-height: rem(100)
      margin: rem(10)
      border: rem(1) solid #D6D6D6
      border-style: dashed
      box-sizing: border-box
      border-radius: rem(4)
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center
      position: relative
      transition: .5s
      overflow: hidden
      outline: none
      &:after
        content: "New area"
        position: absolute
        height: 100%
        width: 100%
        top: 0
        left: 0
        color: #fff
        background: $green
        font-family: 'Montserrat', sans-serif
        font-style: normal
        font-weight: 700
        font-size: rem(12)
        line-height: rem(15)
        display: flex
        flex-direction: column
        justify-content: center
        align-items: center
        transition: .5s
        opacity: 0
        padding: rem(50)
      &:hover
        &:after
          opacity: 1
    &-result
      background: #fff
      box-shadow: none
      cursor: pointer
      border: none
      min-height: rem(116)
      margin: rem(10)
      border: rem(1) solid #D6D6D6
      border-style: dashed
      box-sizing: border-box
      border-radius: rem(4)
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center
      position: relative
      transition: .5s
      overflow: hidden
      outline: none
      text-decoration: none
      font-style: normal
      font-weight: 500
      font-size: rem(12)
      line-height: rem(20)
      color: $red
      svg
        margin-bottom: rem(14)
        path
          transition: .5s
      &:hover
        background: $red
        color: #fff
        font-weight: bold
        svg
          path
            stroke: #fff
</style>
